var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page shipments-module"},[_c('div',{staticClass:"page__sidebar"},[_c('shipments-sidebar')],1),_c('div',{staticClass:"page__main"},[_c('router-view',{staticClass:"page__main-content"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }